import { mediaQuery, RESPONSIVE_PADDING } from 'constants/ui';
import { getScrollStyles } from 'styles/scrollbar.styles';

export const getWrapperStyles = theme => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  flex: 1,
  padding: RESPONSIVE_PADDING.DESKTOP,
  height: '100%',
  overflow: 'auto',
  width: '100%',
  maxWidth: '100%',
  ...getScrollStyles(theme).scroll,

  [mediaQuery.mobile]: {
    padding: RESPONSIVE_PADDING.MOBILE,
    gap: RESPONSIVE_PADDING.MOBILE,
  },
  [mediaQuery.tablet]: {
    padding: RESPONSIVE_PADDING.TABLET,
  },
});

export const emptyMessageCellStyles = {
  padding: 0,
  '& .table-cell__content_box': {
    padding: '8px !important',
    height: 'unset !important',
  },
};

export const tableWrapperStyles = {
  padding: 0,

  [mediaQuery.mobileAndTablet]: {
    overflowX: 'auto',
    '& table': {
      minWidth: '600px',
    },
  },
};
